import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { toast } from 'react-hot-toast';
import { publicLang, publicPath } from '../pages/public/publicPaths';
import { legalDocUrl, openExternal } from '../utils/openExternal.js';
import Sheet from './common/sheet.jsx';
import Button from './common/button.jsx';

function DocLink({ path, language, children }) {
    return (
    <button
      type="button"
      className="consent-doc-link"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        openExternal(legalDocUrl(publicPath(publicLang(language), path)));
      }}
    >
      {children}
    </button>
  );
}

export default function SignupConsentFields({
  acceptedLegalProps,
  acceptedLegalError,
  idPrefix = '',
}) {
  const { t, i18n } = useTranslation(['auth', 'common']);
  const language = i18n.language;
  const legalId = `${idPrefix}acceptedLegal`;

  return (
    <div className="signup-consent">
      <p className="signup-consent-limits">{t('auth:freePlanLimits')}</p>
      <div className="form-check mt-2 mb-1 form-check-consent">
        <input
          {...acceptedLegalProps}
          type="checkbox"
          className="form-check-input"
          id={legalId}
        />
        <label className="form-check-label" htmlFor={legalId}>
          <Trans
            i18nKey="auth:consent"
            components={{
              terms: <DocLink path="/terms" language={language} />,
              privacy: <DocLink path="/privacy" language={language} />,
            }}
          />
        </label>
        {acceptedLegalError && <div className="ms-error">{acceptedLegalError}</div>}
      </div>
    </div>
  );
}

export function hasSignupConsent({ acceptedLegal } = {}) {
  return acceptedLegal === true;
}

export function SocialSignupConsentSheet({ open, onClose, onConfirm }) {
  const { t } = useTranslation(['auth']);
  const [acceptedLegal, setAcceptedLegal] = useState(false);

  const confirm = () => {
    if (!acceptedLegal) return toast.error(t('auth:consentRequired'));
    onConfirm({ acceptedLegal: true });
  };

  return (
    <Sheet open={open} onClose={onClose} title={t('auth:signupConsentTitle')}>
      <SignupConsentFields
        idPrefix="social-"
        acceptedLegalProps={{
          name: 'socialAcceptedLegal',
          checked: acceptedLegal,
          onChange: (e) => setAcceptedLegal(e.target.checked),
        }}
      />
      <Button text={t('auth:signupConsentContinue')} onClick={confirm} />
    </Sheet>
  );
}
